import type { TaggedGDDLEvent } from '@analytics/models';
import { inject, Injectable } from '@angular/core';

import { DATALAYER_OUTPUTS } from '../output/provide-datalayer-outputs';

/**
 * Service responsible for initializing all output channels and dispatching events to all the defined output channels.
 * Events are dispatched based on the `tags` property in the GDDL Event.
 */
@Injectable({
  providedIn: 'root',
})
export class DatalayerOutputManager {
  // List of all outputs
  readonly #outputs = inject(DATALAYER_OUTPUTS, { optional: true }) ?? [];

  /**
   * Waits for the application to have an appropriate consent status and
   * Runs initialization logic on all the output channels.
   */
  initOutputs() {
    for (const output of this.#outputs) {
      output.init();
    }
  }

  /**
   * dispatches the provided event to all appropriate output channels.
   * the `tags` property of the GDDL event determines what output channels are eligible.
   * @param event GDDLEvent with output tagging metadata.
   */
  dispatchEventToOutputs(event: TaggedGDDLEvent) {
    for (const output of this.#outputs) {
      if (output.outputConditionsAreMet()) {
        output.dispatchEvent(event);
      }
    }
  }
}
